import React from 'react';
import { InputLabel, MenuItem } from '@material-ui/core';
import { SettingsSelect } from '../../../../../../BranchDetails/components/BranchComponents';
import { EditableQuestion, QuestionType } from '../../../../../types';
import { Control, Controller } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../styles';
import { ErrorMessage } from '../../../../../../Services/styled-components';

interface Props {
  control: Control<EditableQuestion>;
}

const TypeEditor = ({ control }: Props) => (
  <Controller
    control={control}
    name="type"
    rules={{
      required: { value: true, message: 'Question type is required' },
      pattern: { value: /\S/, message: 'Question type must be non empty string' }
    }}
    render={({ field, formState }) => (
      <StyledQuestionFieldContainer>
        <InputLabel>Question type</InputLabel>
        <SettingsSelect {...field}>
          <MenuItem value={QuestionType.SINGLE_RADIO_SELECTION}>Single radio selection</MenuItem>
          <MenuItem value={QuestionType.MULTI_SELECTION}>Multi selection</MenuItem>
          <MenuItem value={QuestionType.IMAGE_UPLOAD}>Image upload</MenuItem>
          <MenuItem value={QuestionType.FREE_TEXT}>Free text</MenuItem>
        </SettingsSelect>
        <ErrorMessage>{formState.errors.type?.message}</ErrorMessage>
      </StyledQuestionFieldContainer>
    )}
  />
);

export default TypeEditor;
